var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { size: "md", modalId: "modal-lv3" },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("span", { staticClass: "font-semibold text-base" }, [
              _vm._v(_vm._s(_vm.skillsIds.length ? "Edit" : "Add") + " Skills"),
            ]),
            _c(
              "span",
              {
                staticClass:
                  "cursor-pointer flex items-center justify-center absolute top-4 right-7",
                on: {
                  click: _vm.closeModal,
                  mouseover: function ($event) {
                    _vm.isHovered = true
                  },
                  mouseout: function ($event) {
                    _vm.isHovered = false
                  },
                },
              },
              [
                !_vm.isHovered
                  ? _c("CrossIcon", { staticClass: "h-3.5 w-3.5" })
                  : _vm._e(),
                _vm.isHovered
                  ? _c("CrossIconHover", { staticClass: "close-icon" })
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "ModalContent",
              { staticClass: "relative" },
              [
                _c(
                  "FormGroup",
                  {
                    staticClass: "mt-5",
                    attrs: {
                      title: "Select Skills (50 Max)",
                      inputClass: "fullwidthInput",
                    },
                  },
                  [
                    _c("SkillsMultiselect", {
                      attrs: {
                        max: 50,
                        pillsColor: "resumeSkill",
                        getParentStyle: "fullWidthInput",
                      },
                      model: {
                        value: _vm.skillsIds,
                        callback: function ($$v) {
                          _vm.skillsIds = $$v
                        },
                        expression: "skillsIds",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "flex justify-end mt-2 pt-3 gap-2" },
                  [
                    _c("UIButton", {
                      attrs: {
                        buttonText: "Cancel",
                        size: "lg",
                        variant: "outline",
                        processing: _vm.processing,
                      },
                      on: { click: _vm.closeModal },
                    }),
                    _c("UIButton", {
                      attrs: {
                        buttonText: _vm.skillsIds.length ? "Save" : "Add",
                        size: "lg",
                        variant: "black",
                        processing: _vm.processing,
                      },
                      on: {
                        click: () => {
                          _vm.addSkill()
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }